import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

/**
 * PersonalNoteContent document interface
 */
export interface PersonalNoteContentDocument extends BaseDocument {
  personalNoteId: string
  content: string
  format: string
  length: number
  plainText?: string | null
  version: number
  createdOn: number
  updatedOn: number
  deletedOn?: number | null
}

/**
 * PersonalNoteContent-specific hooks
 */
const hooks = createEntityHooks<PersonalNoteContentDocument>('personalnotecontents')

// Queries by personalNoteId (1:1 relationship)
export const usePersonalNoteContent = (personalNoteId: string | undefined) => {
  const enabled = !!personalNoteId
  const { data, isLoading } = hooks.useEntities(
    enabled ? { personalNoteId: personalNoteId!, isDeleted: false } : undefined,
    { enabled },
  )
  return { content: data[0] || null, isLoading }
}

/** Every note content row the user has, for list previews. */
export const usePersonalNoteContents = () => {
  const { data, isLoading } = hooks.useEntities({ isDeleted: false })
  return { contents: data, isLoading }
}

export const usePersonalNoteContentMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createPersonalNoteContent: create,
    updatePersonalNoteContent: update,
    deletePersonalNoteContent: deleteEntity,
  }
}
